import {
  contractTypeEnum,
  type ContractType,
} from '@ts-max/car-export-enum-sdk';

/**
 * 判断合同类型是否属于销售合同，用于统一销售侧回款文案和流程分支。
 */
export function isSaleContractType(contractType: ContractType): boolean {
  return (
    contractType === contractTypeEnum.DOMESTIC_SALE_CONTRACT ||
    contractType === contractTypeEnum.FOREIGN_SALE_CONTRACT
  );
}
